module.exports = __webpack_public_path__ + "img/icon3.531f9b13.png";